/** Pendant zu `<SfNumericTextBox @bind-Value=Model.Feld … />` samt `<ValidationMessage>`. */

import { NumericTextBox } from '@/components/ui';

import { asNumber, type FieldAccess } from './fieldAccess';
import { FormField } from './FormField';

export interface NumericFieldProps<T> {
  form: FieldAccess<T>;
  name: keyof T & string;
  /** Beschriftung über dem Feld — Text unverändert aus REQ-10 §3/§4. */
  label: string;
  /**
   * `TValue="decimal?"` im Altclient. Bei `false` (`TValue="decimal"`) schreibt Syncfusion
   * beim Leeren `default(decimal)`, also `0`.
   */
  nullable: boolean;
}

export function NumericField<T>(props: NumericFieldProps<T>) {
  const { form, name } = props;
  const field = form.viewField(name);
  if (field === null) return null;

  return (
    <FormField message={form.message(name)}>
      <NumericTextBox
        value={asNumber(form.value(name))}
        label={props.label}
        readOnly={field.ReadOnly}
        onChange={(value) => {
          form.setValue(name, props.nullable ? value : (value ?? 0));
        }}
      />
    </FormField>
  );
}

export default NumericField;
